import {testIdProps} from '@github-ui/test-id-props'
import {useNamedColor} from '@github-ui/use-named-color'
import {ProgressBar} from '@primer/react'
import {clsx} from 'clsx'

import styles from './progress-bar.module.css'
import type {ProgressBarCustomProps} from './types'

export const ProgressBarSolid = ({
  color,
  completed,
  consistentContentSizing,
  hideNumerals,
  name,
  percentCompleted,
  total,
  ...progressBarProps
}: ProgressBarCustomProps) => {
  const {accent} = useNamedColor(color)

  const containerClasses = clsx(styles.containerSolid, {
    [`${styles.consistentContentSizing}`]: consistentContentSizing,
  })

  return (
    <div className={containerClasses} {...testIdProps('progress-bar-solid')}>
      {!hideNumerals && (
        <span className={styles.textCount}>
          {completed} / {total}
        </span>
      )}

      <ProgressBar className={styles.solid} inline {...progressBarProps}>
        <ProgressBar.Item
          // Adding aria-hidden since the percent span conveys the information
          aria-hidden
          progress={percentCompleted}
          className={styles.barItemComplete}
          style={{backgroundColor: accent}}
        />
        <ProgressBar.Item
          // Adding aria-hidden since the percent span conveys the information
          aria-hidden
          progress={100 - percentCompleted}
          className={styles.barItemIncomplete}
          style={{backgroundColor: accent}}
        />
      </ProgressBar>

      {!hideNumerals && <span className={styles.textPercentage}>{percentCompleted}%</span>}
    </div>
  )
}

try{ ProgressBarSolid.displayName ||= 'ProgressBarSolid' } catch {}